import config from '../config/config'
import axios from 'axios'
import { getToken } from '../common'; 

export const deleteEventItemAPI = async (params) => {

    return await axios({
        method  : 'delete',
        url     : `${config.api.base_url}events/${params.eventId}/item/${params.eventItemId}`,
        // data    : params,
        headers : {
            "Content-type": "application/json; charset=UTF-8",
            "Authorization": getToken(),
        }
    })
}

export default deleteEventItemAPI